<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.GRID.WORKFLOWS)}}</h2>
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="workflow-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="workflow-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="search-grid">
          <div class="search-field">
            <label>{{_(KEYS.GRID.NAME)}}</label>
            <input class="form-control" [(ngModel)]="filter.name"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>
          <div class="search-field">
            <label>{{_(KEYS.GRID.DESCRIPTION)}}</label>
            <input class="form-control" [(ngModel)]="filter.description"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>

          <div class="search-field span-2">
            <label>{{_(KEYS.GRID.QUESTIONNAIRES)}}</label>
            <app-select2
              [hideLabel]="true"
              [hideButton]="true"
              [multiple]="true"
              [options]="{width: '100%', placeholder: '...'}"
              [(selected)]="filter.questionnaires"
              (selectedChange)="onFilterChange()"
            >
              <option *ngFor="let q of questionnaires" [value]="q.id">
                {{q.meta.title[locale] || q.meta.title[defaultLocale] || '???'}}
              </option>
            </app-select2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
            <label class="btn btn-sm btn-success mb-0 ml-2"
                   ngbTooltip="{{_(KEYS.GRID.IMPORT_WORKFLOW)}}" placement="top">
              <i class="fa fa-upload"></i>
              <input type="file" accept=".zip,application/zip"
                     (change)="onImportWorkflowFileSelected($event)" hidden>
            </label>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="workflow-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.WORKFLOWS)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="workflow-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="table-scroll-container">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="id-col qa-cursor-pointer" (click)="onSortChange('uid')">
              {{_(KEYS.GRID.ID)}}
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('name.de_DE')">
              {{_(KEYS.GRID.NAME)}}
              <i *ngIf="filter.sort === 'name.de_DE' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'name.de_DE' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('description.de_DE')" style="min-width:160px;">
              {{_(KEYS.GRID.DESCRIPTION)}}
              <i *ngIf="filter.sort === 'description.de_DE' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'description.de_DE' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('stages')">
              {{_(KEYS.GRID.STAGES)}}
              <i *ngIf="filter.sort === 'stages' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'stages' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('createdBy')">
              {{_(KEYS.GRID.USER)}}
              <i *ngIf="filter.sort === 'createdBy' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'createdBy' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('createdAt')">
              {{_(KEYS.GRID.CREATED_AT)}}
              <i *ngIf="filter.sort === 'createdAt' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'createdAt' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('updatedAt')">
              {{_(KEYS.GRID.UPDATED_AT)}}
              <i *ngIf="filter.sort === 'updatedAt' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'updatedAt' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="text-right">{{_(KEYS.GRID.OPTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let workflow of workflows; let pos = index;">
            <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}">
              <td class="id-col">
                <span ngbTooltip="{{workflow.uid}}">{{workflow.uid | truncate: 5}}</span>
              </td>
              <td>
                {{(workflow.name || {})[locale] || (workflow.name || {})[defaultLocale] || '?'}}
              </td>
              <td>
                {{(workflow.description || {})[locale] || (workflow.description || {})[defaultLocale] || ''}}
              </td>
              <td class="workflow-stages-cell">
                <ol class="workflow-stages" *ngIf="workflow.stages && workflow.stages.length; else noStages"
                    [attr.aria-label]="_(KEYS.GRID.STAGES)">
                  <li class="stage" *ngFor="let stage of workflow.stages; let stagePos = index;">
                    <span class="stage-number" aria-hidden="true">{{stagePos + 1}}</span>
                    <div class="stage-content">
                      <div class="stage-head">
                        <span class="stage-title">{{(stage.name || {})[locale] || (stage.name || {})[defaultLocale]
                          || _(KEYS.GRID.STAGE) + ' ' + (stagePos + 1)}}</span>
                        <div class="stage-indicators">
                        <span class="stage-indicator" [class.is-enabled]="stage.generateExports"
                              role="img" [attr.aria-label]="_(KEYS.GRID.GENERATE_EXPORTS) + ': ' + _(stage.generateExports ? KEYS.GRID.ENABLED : KEYS.GRID.DISABLED)"
                              [ngbTooltip]="_(KEYS.GRID.GENERATE_EXPORTS) + ': ' + _(stage.generateExports ? KEYS.GRID.ENABLED : KEYS.GRID.DISABLED)"
                              container="body">
                          <i class="fa fa-download" aria-hidden="true"></i>
                        </span>
                        <span class="stage-indicator" [class.is-enabled]="stage.generateFormPDFs"
                              role="img" [attr.aria-label]="_(KEYS.GRID.GENERATE_FORM_PDFS) + ': ' + _(stage.generateFormPDFs ? KEYS.GRID.ENABLED : KEYS.GRID.DISABLED)"
                              [ngbTooltip]="_(KEYS.GRID.GENERATE_FORM_PDFS) + ': ' + _(stage.generateFormPDFs ? KEYS.GRID.ENABLED : KEYS.GRID.DISABLED)"
                              container="body">
                          <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                        </span>
                        <span class="stage-indicator" [class.is-enabled]="stage.prefill"
                              role="img" [attr.aria-label]="_(KEYS.GRID.PREFILL) + ': ' + _(stage.prefill ? KEYS.GRID.ENABLED : KEYS.GRID.DISABLED)"
                              [ngbTooltip]="_(KEYS.GRID.PREFILL) + ': ' + _(stage.prefill ? KEYS.GRID.ENABLED : KEYS.GRID.DISABLED)"
                              container="body">
                          <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </span>
                        </div>
                      </div>
                      <div class="stage-questionnaires" *ngIf="stage.questionnaires && stage.questionnaires.length; else noQuestionnaires">
                        <div class="stage-questionnaire" *ngFor="let questionnaireId of stage.questionnaires">
                          <ngmedax-questionnaire-origin
                            *ngIf="questionnaireById[questionnaireId]; else questionnaireMissing"
                            [questionnaire]="questionnaireById[questionnaireId]"
                            [locale]="locale"
                            mode="stacked">
                          </ngmedax-questionnaire-origin>
                          <ng-template #questionnaireMissing>
                            <span class="stage-empty" [title]="questionnaireId">{{_(KEYS.GRID.QUESTIONNAIRE_UNAVAILABLE)}}</span>
                          </ng-template>
                        </div>
                      </div>
                      <ng-template #noQuestionnaires><span class="stage-empty">{{_(KEYS.GRID.NO_QUESTIONNAIRES)}}</span></ng-template>
                    </div>
                  </li>
                </ol>
                <ng-template #noStages><span class="stage-empty">{{_(KEYS.GRID.NO_STAGES)}}</span></ng-template>
              </td>
              <td>
                {{workflow.createdBy || ''}}
              </td>
              <td style="min-width:135px;">
                {{workflow.createdAt | datex:dateFormat}}
              </td>
              <td style="min-width:135px;">
                {{workflow.updatedAt | datex:dateFormat}}
              </td>
              <td class="text-right options">
                <a class="btn btn-sm btn-primary"
                   [routerLink]="['/module/workflow/crud', workflow.id]"
                   ngbTooltip="{{_(KEYS.GRID.EDIT)}}"
                   placement="top">
                  <i class="fa fa-edit"></i>
                </a>
                <button class="btn btn-sm btn-success ml-1"
                        (click)="onExportWorkflow(workflow)"
                        ngbTooltip="{{_(KEYS.GRID.EXPORT_WORKFLOW)}}"
                        placement="top">
                  <i class="fa fa-download"></i>
                </button>
                <button class="btn btn-sm btn-danger ml-1"
                        (click)="onDeleteWorkflow(workflow)"
                        ngbTooltip="{{_(KEYS.GRID.DELETE)}}"
                        placement="top">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>
        </div>
        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
